import { TOGGLE_ANNOTATIONS_VISIBILITY_CLICK } from '../../stateManager/collaborations/types';

export function toggleAnnotationsVisible() {
    return {
        type: TOGGLE_ANNOTATIONS_VISIBILITY_CLICK
    };
}
